"use strict";
import { EnvelopeHeartIcon } from "components/Icons/EnvelopeHeart";
import Row from "components/Row";
import styled from "lib/styled-components";
import { ExternalLink } from "theme/components";
import { Trans } from "uniswap/src/i18n";
const StyledExternalLink = styled(ExternalLink)`
  width: fit-content;
  border-radius: 16px;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 485;
  line-height: 20px;
  background: ${({ theme }) => theme.surface2};
  color: ${({ theme }) => theme.neutral2};
  :hover {
    background: ${({ theme }) => theme.surface3};
    color: ${({ theme }) => theme.neutral1};
    path {
      fill: ${({ theme }) => theme.neutral1};
    }
    opacity: unset;
  }
  stroke: none;
`;
export default function GetHelp() {
  return <StyledExternalLink href="https://swap-support.protofire.io/"><Row gap="4px">
    <EnvelopeHeartIcon />
    <Trans i18nKey="common.getHelp.button" />
  </Row></StyledExternalLink>;
}
